require.register("app/product/show/SimilarTab", function(exports, require, module){
  $0
  
});

